export default function getLoadBalancerDataCenterServerReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_LOAD_BALANCER_DATA_CENTER_SERVER_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_LOAD_BALANCER_DATA_CENTER_SERVER_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_LOAD_BALANCER_DATA_CENTER_SERVER_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}